// トップ menu 画面 (= DDSIM-21、 ADR-0026 §E)。
// 旧 duel-drive 踏襲の縦並び full menu。 SOLO は serverless 経路で /practice (setup) へ。

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ConnectDialog } from "@/components/ConnectDialog";
import { Button } from "@/components/ui/button";

export function Menu(): JSX.Element {
  const navigate = useNavigate();
  const [connectOpen, setConnectOpen] = useState<boolean>(false);

  return (
    <main className="min-h-screen bg-background flex flex-col items-center justify-center gap-8 p-8">
      <h1 className="text-4xl font-bold tracking-widest">DUEL DRIVE SIM</h1>

      <nav className="flex flex-col items-center gap-3 w-full max-w-xs">
        <Button className="w-full" onClick={() => navigate("/practice")}>
          SOLO
        </Button>

        <Button
          className="w-full"
          variant="outline"
          onClick={() => setConnectOpen(true)}
        >
          ONLINE
        </Button>

        <div className="w-full space-y-1">
          <Button className="w-full" variant="outline" disabled>
            DECK
          </Button>
          <p className="text-center text-xs text-muted-foreground">準備中</p>
        </div>

        <div className="w-full space-y-1">
          <Button className="w-full" variant="outline" disabled>
            OPTIONS
          </Button>
          <p className="text-center text-xs text-muted-foreground">準備中</p>
        </div>

        <div className="w-full space-y-1">
          {/* Tauri Phase 1.5 で有効化予定 */}
          <Button className="w-full" variant="outline" disabled>
            QUIT
          </Button>
          <p className="text-center text-xs text-muted-foreground">Web 無効</p>
        </div>
      </nav>

      <ConnectDialog open={connectOpen} onOpenChange={setConnectOpen} />
    </main>
  );
}
